import React, {FC} from 'react';
import './TICGeneralInformation.module.scss';
import {ReactComponent as Timeline} from './../../../assets/images/timeline.svg';
import {Stack} from "@mui/material";
import styles from "../SecurityGuidelines/SecurityGuidelines.module.scss";
import {Helmet} from "react-helmet";


interface TicGeneralInformationProps {
}

const TicGeneralInformation: FC<TicGeneralInformationProps> = () => (

    <><>
        <Helmet>
            <meta charSet="utf-8"/>
            <title>TIC General Information</title>
        </Helmet>
        <div className={styles.TicGeneralInformation}>
            <div className="standard-margin">
            <h1>Technical Information Center</h1>
            <hr></hr>
            <span>
                <p>The Technical Information Center (TIC) at the Denver Service Center (DSC) began in 1965 as the Branch of
                    Micrographics for the Western Office of Design in San Francisco, California. Comprehensive, user-friendly
                    and
                    cost effective; TIC’s information system was planned, developed and refined over 50 years. It is the oldest
                    and largest information system in the National Park Service (NPS). TIC is designated by the Service as the
                    central repository for managing all NPS-generated drawings, specifications, scientific and technical
                    reports.
                    <br></br> <br></br>
                    Source documents are scanned for inclusion in the system and converted to PDF (Portable Document Format) or
                    TIF (Tagged Image File) electronic formats. TIC’s bibliographic database lists and tracks the data,
                    including
                    document images.
                    <br></br> <br></br>
                    eTIC (electronic Technical Information Center) provides an intranet interface to the database for
                    service-wide
                    access to search the collection and view or download images. TIC and DIS provide document delivery for items
                    in the database. eTIC is capable of accessing the technical information holdings of the Park Service
                    providing
                    details such as format, author, dates, and location of source documents.
                </p>  </span>

            <h2> TIC Database and Collection Description</h2>
            <h3>
                PLANNING, RESOURCE MANAGEMENT, & DEVELOPMENT TYPE DOCUMENTS

            </h3>
            These documents establish guidelines for the overall use, preservation, management, and development of areas
            within the National Park System. Included are:
        </div>
        </div>
           <Stack direction="row" spacing={2}>
            <span className="standard-margin">
                <ul>
                    <li> Air Quality Studies</li>
                    <li> Archaeological Investigation Reports</li>
                    <li> Archeological Research & Salvage Studies</li>
                    <li> Concession Management Plans</li>
                    <li> Cultural Resource Preservation Guides</li>
                    <li> Cultural Resource Studies</li>
                    <li> Environmental Assessments / Studies</li>
                    <li> Environmental Statements</li>
                    <li> Fire Management Studies</li>
                    <li> General Management Plans</li>
                    <li> Historic Furnishing Plans</li>
                    <li> Historic Resource Studies</li>
                    <li> Interpretive Prospectuses / Plans</li>
                    <li> Land Acquisition Maps / Studies</li>
                    <li> Land Protection Plans</li>
                    <li> Land Use Studies</li>
                    <li> Legislative Support Data</li>
                    <li> Management Zoning Maps</li>
                    <li> Mining and Minerals Studies</li>
                    <li> National Natural Landmark Investigations</li>
                    <li> National Scenic Trail Studies</li>
                </ul>
            </span>

            <span>
                <ul>
                    <li> Natural Resource Studies</li>
                    <li> New Area Studies</li>
                    <li> Outline of Planning Requirements</li>
                    <li> Park Administrative Histories</li>
                    <li> Pest Control Measures Used in Parks</li>
                    <li> Regional Plans</li>
                    <li> Research Permits</li>
                    <li> Resource Aerial Photography</li>
                    <li> Resource Base Information</li>
                    <li> Resource Case Protection Studies</li>
                    <li> Resource Management & Assessment Plans</li>
                    <li> Scientific Studies</li>
                    <li> Special Resource Studies</li>
                    <li> Statements for Management</li>
                    <li> Suitability / Feasibility Studies</li>
                    <li> Transportation Studies</li>
                    <li> Visitor Use Studies</li>
                    <li> Water Resources Studies</li>
                    <li> Wild and Scenic River Studies</li>
                    <li> Wilderness Studies</li>
                </ul>
            </span>
        </Stack>

        <p className="standard-margin">
            <hr></hr>
            Design and Construction Drawings and Related Documents
            These drawings and documents are utilized in the planning, development, construction, modification and
            repair of buildings and facilities within the parks. They may also include specifications and other
            design-related documents. Drawings may be prepared by NPS, a private professional
            architectural/engineering
            firm for NPS, a professional staff hired by a concessionaire, or other agencies.
        </p>

        {/*Second set*/}
        <Stack direction="row" spacing={2}>
            <span className="standard-margin">
                              <ul>
                                        <li>Bridge Studies</li>
                                        <li>Site Analysis Studies (report or drawing format)</li>
                                        <li>Construction Drawings (not preceded by a preliminary drawing)</li>
                                        <li>Development Advisory Board Five-year Plan Design Analysis</li>
                                        <li>Design Presentation Drawings</li>
                                        <li>Environmental Assessments (design level)</li>
                                        <li>Environmental Statements (design level)</li>
                                        <li>Historic Structure Reports</li>
                                        <li>Design Development Drawings</li>
                                        <li>Radio System Studies</li>
                                        <li>Road Studies</li>
                                        <li>Schematic Designs</li>
                                        <li>Site Plans</li>
                                    </ul>            </span>

            <span>
               <ul>
                                        <li>Amendment Drawings</li>
                                        <li>Construction Drawings (including those of Historic Structures)</li>
                                        <li>Furnishings and Equipment Drawings</li>
                                        <li>Modification Drawings</li>
                                        <li>Museum Exhibit Drawings</li>
                                        <li>Radio System Drawings</li>
                                        <li>Shop Drawings</li>
                                        <li>Space Assignment Drawings</li>
                                    </ul>
            </span>
        </Stack>

    </>
        <div className="standard-margin">
            <p><span className="lessBold">Post-construction documents:</span> Consist of as-constructed drawings,
                historic structures preservation guides
                and operating and maintenance manuals. These documents are important for use in maintenance and
                modifications of facilities.</p>
            <p><span className="lessBold">Related Documents:</span> Other documents in the TIC collection include
                boundary surveys, land status maps,
                survey monument maps, and right-of-way drawings.</p>

        <hr></hr>
        <h2>History of the Technical Information Center (TIC)
        </h2>
        <h3>TIC and MICRO Timeline
        </h3>
        </div>
        <Timeline/><br></br><br></br>

    </>

);

export default TicGeneralInformation;
